import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    otherFieldsOfActivity: checkText(settings),
});

export const FieldsOfActivitySubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            {
                values.fieldsOfActivity.map((field, index) =>
                    <Form.Group className="mb-3" key={index}>
                        <Form.Check
                            id={field.displayName}
                            label={field.displayName}
                            onChange={(event) => {
                                field.onChange(event);
                                handleChange(event);
                            }}
                        />
                    </Form.Group>
                )
            }

            <Form.Group className="mb-3" controlId='otherFieldsOfActivity'>
                <Form.Label>Sonstiges</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder='Sonstiges'
                    type="text"
                    name='otherFieldsOfActivity'
                    value={values.otherFieldsOfActivity}
                    isValid={touched.otherFieldsOfActivity && !errors.otherFieldsOfActivity}
                    isInvalid={errors.otherFieldsOfActivity}
                    maxLength={settings.textInputLimit}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                </CustomFormControl>
                <Form.Control.Feedback type="invalid">
                    {errors.otherFieldsOfActivity}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};